import React from "react";
import Modal from "../modal";

const CoachRecordVideoModal = ({ videoRecord }) => {
  return (
    <Modal width="" className="coach-record-video">
      <div className="head">Record video from coach</div>
      <div className="body coach-record-video-modal">
        <div
          dangerouslySetInnerHTML={
            videoRecord &&
            videoRecord.video_html && {
              __html: videoRecord.video_html.replace(/(&lt;([^>]+)>)/gi, ""),
            }
          }
        ></div>
      </div>
    </Modal>
  );
};

export default CoachRecordVideoModal;
